import './src/vaadin-menu-bar.js';
export * from './src/vaadin-menu-bar.js';
